<template>
  <modal-component
    :label="label"
    :buttonLabel="buttonLabel"
    label-align="center"
    :body-scroll="false"
    @aceptar="enviar"
    @close="onClose"
    :show="show"
  >
    <div class="content">
      <p>Te enviaremos un SMS con un link para que puedas continuar</p>
      <phone-number
        v-model="model.celular"
        :required="true"
        :quantumObfuscate="quantumObfuscate"
      />
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "@/components/core/ModalComponent";
import PhoneNumber from "@/components/core/composite/PhoneNumber";

export default {
  name: "ModalSms",
  data() {
    return {
      model: this.$store.getters.getConsulta(),
      color: "#1973b8",
      label: "Ingresá tu número de celular",
      width: "206px"
    };
  },
  components: {
    PhoneNumber,
    ModalComponent
  },
  props: {
    value: Object,
    buttonLabel: String,
    show: { type: Boolean, default: false },
    mensaje: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    enviar() {
      const celular = this.model.celular.normalizado;
      const telefono = celular.area + celular.caracteristica + celular.nro;
      let url = `${window.location.href}?hash=${window.hash}`;
      let mensaje = {
        numeroDeCelular: telefono,
        mensaje: "&#33;Hola, " + this.model.nombre + "! " + this.mensaje + url
      };
      this.$emit("sendSMS", mensaje);
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
    }
  }
};
</script>

<style scoped>
.content {
  text-align: center;
}

img {
  width: 81px;
  height: 81px;
}

.title {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: center;
  color: #121212;
}

.subtitle {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: center;
  color: #121212;
  padding-left: 21%;
  padding-right: 21%;
}

.boton_change {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.change {
  grid-row: 1;
  grid-column: 2;
  padding-left: 15%;
}

.forward {
  grid-row: 1;
  grid-column: 3;
  padding-left: 15%;
}
</style>
